import { fetchApi } from './api'
import type { EtlRunDetail, EtlRunListItem, EtlRunQuery } from '../types/etlRuns'

const BASE = '/api/observatory/runs'

/**
 * Entity runs, newest first.
 *
 * Only the parameters actually asked for are set, as getConnections does. An
 * empty string is a value to the model binder, not an absent filter —
 * `entityName=` would match rows whose entity is the empty string, of which
 * there are none, so a blank text box would silently return nothing rather than
 * everything.
 */
export function getEtlRuns(query: EtlRunQuery = {}): Promise<EtlRunListItem[]> {
  const params = new URLSearchParams()

  if (query.limit != null) params.set('limit', String(query.limit))
  if (query.entityName) params.set('entityName', query.entityName)
  if (query.module) params.set('module', query.module)

  const qs = params.toString()
  return fetchApi<EtlRunListItem[]>(`${BASE}${qs ? `?${qs}` : ''}`)
}

/** One entity run in full. 404s once it has passed its retention window. */
export function getEtlRun(runId: string): Promise<EtlRunDetail> {
  return fetchApi<EtlRunDetail>(`${BASE}/${encodeURIComponent(runId)}`)
}
